import config from '../config';

export default (freeslots: any) => {
    let apmTypes = [];

    for (let slot in freeslots) {
        apmTypes.push(config.appointman.apmTypeMapping[slot]);
    }

    return apmTypes;
};



// WEBPACK FOOTER //
// ./app/bundles/appointman/app/ts/utils/extractApmTypes.ts